import { WorkStateMap } from './work-state-map';
import { WorkStates } from './work-states';

export function getStates<ID, RESULT>(map: WorkStateMap<ID, RESULT>, id: ID): WorkStates<RESULT> {
  return {
    isLoading$: map.isLoading$(id),
    isSuccess$: map.isSuccess$(id),
    successEvents$: map.successEvent$(id),
    workResults$: map.getWorkResults$(id),
  };
}
